var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import { space } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import PropTypes from 'prop-types';
import { applyVariations, getPaletteColor, borders, deprecatedColorValue } from '../utils';
var propTypes = __assign({ id: PropTypes.string.isRequired, color: deprecatedColorValue() }, space.propTypes);
var TextArea = styled.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  display: block;\n  width: 100%;\n  font-family: inherit;\n  font-size: ", "px;\n  color: inherit;\n  background-color: transparent;\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n\n  padding-top: 14px;\n  padding-bottom: 14px;\n  padding-left: 12px;\n  padding-right: 12px;\n\n  margin: 0;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  ", "\n  ", " ", ";\n"], ["\n  appearance: none;\n  display: block;\n  width: 100%;\n  font-family: inherit;\n  font-size: ", "px;\n  color: inherit;\n  background-color: transparent;\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n\n  padding-top: 14px;\n  padding-bottom: 14px;\n  padding-left: 12px;\n  padding-right: 12px;\n\n  margin: 0;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  ", "\n  ", " ", ";\n"])), themeGet('fontSizes.1'), themeGet('borderRadii.lg'), getPaletteColor('text.light'), applyVariations('TextArea'), borders, space);
TextArea.displayName = 'TextArea';
TextArea.isField = true;
TextArea.propTypes = propTypes;
export default TextArea;
var templateObject_1;
//# sourceMappingURL=TextArea.js.map